module.exports = __webpack_public_path__ + "img/unlocked.d7f26809.svg";